import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/NPLChargingStationDetails/Get`, payload),
    Add: (payload) => Repository.post(`/api/NPLChargingStationDetails/Add`, payload),
    Edit: (payload) => Repository.post(`/api/NPLChargingStationDetails/Edit`, payload),
}
